import React from 'react';
import { Button } from '@mui/material';
import { motion, useReducedMotion } from 'framer-motion';
import classnames from 'classnames/bind';
import styles from './Hero.module.scss';

const cx = classnames.bind(styles);

export default function Hero() {
    const reduceMotion = useReducedMotion();

    const fadeUp = (delay: number) =>
        reduceMotion
            ? {}
            : {
                  initial: { opacity: 0, y: 28 },
                  animate: { opacity: 1, y: 0 },
                  transition: { duration: 0.7, delay, ease: 'easeOut' },
              };

    return (
        <section className={cx('Hero')}>
            <div className={cx('Inner')}>
                <motion.p className={cx('Eyebrow')} {...fadeUp(0)}>
                    Your AI avatar for social media
                </motion.p>

                <motion.h1 className={cx('Title')} {...fadeUp(0.08)}>
                    Put your social media on autopilot. <em>A real one.</em>
                </motion.h1>

                <motion.p className={cx('Subtitle')} {...fadeUp(0.16)}>
                    Shadowpilot is an autonomous, self-learning AI avatar. Connect your LinkedIn,
                    tell it what you&apos;re after and who matters to you — a new job, leads for
                    your business, an audience for your product. From then on it shows up every day
                    and flies toward that goal on your behalf.
                </motion.p>

                <motion.div className={cx('Actions')} {...fadeUp(0.24)}>
                    <Button
                        variant='contained'
                        color='primary'
                        size='large'
                        href='#waitlist'
                        className={cx('PrimaryButton')}
                    >
                        Join the waitlist
                    </Button>
                    <Button
                        variant='text'
                        color='inherit'
                        size='large'
                        href='#how-it-works'
                        className={cx('SecondaryButton')}
                    >
                        See how it works ↓
                    </Button>
                </motion.div>

                <motion.p className={cx('Microcopy')} {...fadeUp(0.32)}>
                    in active development · LinkedIn first · waitlist open
                </motion.p>
            </div>
        </section>
    );
}
